import { DataRecoveryActions } from './actions'
import { DataRecoveryGetters } from './getters'
import { DataRecoveryMutations } from './mutations'
import { DataRecoveryState } from './state'

export const DATA_RECOVERY_NAMESPACE = 'dataRecovery'

export const DataRecovery = {
  actions: DataRecoveryActions,
  getters: DataRecoveryGetters,
  mutations: DataRecoveryMutations,
  namespaced: true,
  state: DataRecoveryState,
}
